import ss from '@/helpers/sessionStorage';

// maps url parameters to endpoint parameter names
const VARIABLES = {
  PIReferral: 'piReferral',
  utm_campaign: 'marketingProgram',
  utm_source: 'marketingSource',
  utm_code: 'depositPromoCode',
  instant_credit: '',
};

function check(route) {
  Object.keys(VARIABLES).forEach((key) => {
    const value = route.query[key];
    if (value) {
      ss.set(key, value);
    }
  });
}


function get(name) {
  const value = ss.get(name, null);
  if (value !== null) {
    return {
      name: VARIABLES[name],
      value,
    };
  }
  return null;
}

function payload(oldPayload, ...names) {
  const data = {};
  names.forEach((name) => {
    const value = ss.get(name, null);
    if (value !== null) {
      data[VARIABLES[name]] = value;
    }
  });
  return {
    ...oldPayload,
    ...data,
  };
}


export default {
  check,
  get,
  payload,
};



// WEBPACK FOOTER //
// ./src/helpers/sessionVars.js